import router from "@/router";
import axios from "axios"; //引入
import { tool } from "@/utils/tool";
import { Message } from "element-ui"; // 导入自己要用的ui组件库
import { MessageBox } from 'element-ui';
import sysConfig from "@/config";
let baseUrl = '';
let isMobile = tool.isMobile()
//这一步的目的是判断出当前是开发环境还是生成环境，方法不止一种，达到目的就行
if (process.env.NODE_ENV == "development") {
    // 开发环境
    baseUrl = process.env.VUE_APP_URL
} else {
    // 生产环境
    baseUrl = process.env.VUE_APP_URL
}

let config = {
    baseURL: baseUrl,
    timeout: 0, //设置最大请求时间
};
const _axios = axios.create(config);

/* 请求拦截器（请求之前的操作） */
_axios.interceptors.request.use(
    (config) => {
        let token = tool.getToken();
        if (token) {
            config.headers[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token
        }
        return config;
    },
    (err) => Promise.reject(err)
);

/* 请求之后的操作 */
_axios.interceptors.response.use(
    (res) => {
        if (res.data.message == 'notUser') {
            tool.loginOut()
            router.push({
                name: 'loading', query: {
                    projectId: sessionStorage.getItem('projectId'),
                }
            })
            Message.error({
                message: '不存在此用户信息',
                offset: isMobile ? (window.innerHeight / 3) : 20
            });
            return
        }//查找不到该用户

        if (res.data.message == 'notProject') {
            router.push({
                name: 'notFound', query: {
                    projectId: sessionStorage.getItem('projectId'),
                }
            })
            Message.error({
                message: '不存在该配置信息',
                offset: isMobile ? (window.innerHeight / 3) : 20
            });
            return
        }//项目projectId不正确

        //关闭请求时的loading动画
        //返回401无权限，可能会是跳回到登录页的操作，结合项目写
        if (res.data.code === 401) {
            router.push({
                name: 'login', query: {
                    projectId: sessionStorage.getItem('projectId'),
                }
            })
            Message.error({
                message: res.data.message,
                offset: isMobile ? (window.innerHeight / 3) : 20
            });
        }
        if (res.data.code === 500) {

            Message.error({
                message: res.data.message,
                offset: isMobile ? (window.innerHeight / 3) : 20
            });
        }
        if (res.data.code === 400) {
            Message.error({
                message: res.data.message,
                offset: isMobile ? (window.innerHeight / 3) : 20
            });


        }
        if (res.data.code === 404) {
            Message.error("");
        }
        return res.data; // 按需导出res的字段
    },
    (err) => {
        if (err) {

            //在这里关闭请求时的loading动画效果
            Message.error({
                message: '接口请求错误',
                offset: isMobile ? (window.innerHeight / 3) : 20
            });
        }
        // return Promise.reject(err);
        return Promise.reject(err);
    }
);


// methods可变的请求方式
const request = (methods, url = "", params = {}) => {
    let paramsRequest = {
        url,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: methods,
    };
    // get请求使用params
    if (methods === "get" || methods === "GET") {
        paramsRequest.params = params;
    } else {
        // post put 请求使用data
        paramsRequest.data = params;
    }
    return new Promise((resolve, reject) => {
        _axios(paramsRequest)
            .then((res) => {
                resolve(res);
                return res;
            })
            .catch((error) => {
                reject(error);
            });
    });
};
export default request;
